import { create } from 'zustand';
import type { ProductListQuery } from '../types';

interface FiltersState extends ProductListQuery {
  setFilter: <K extends keyof ProductListQuery>(key: K, value: ProductListQuery[K]) => void;
  setPage: (page: number) => void;
  reset: () => void;
}

const INITIAL: ProductListQuery = {
  page: 1,
  limit: 20,
  sortBy: 'displayOrder',
  order: 'asc',
};

export const useProductFilters = create<FiltersState>((set) => ({
  ...INITIAL,
  setFilter: (key, value) =>
    // Any non-page filter change resets to page 1 — matches the Users module's
    // filters.store.ts convention (search+pagination interaction, architecture §7.1).
    set((s) => ({ ...s, [key]: value, page: key === 'page' ? (value as number) : 1 })),
  setPage: (page) => set({ page }),
  reset: () => set({ ...INITIAL }),
}));

const QUERY_KEYS: (keyof ProductListQuery)[] = [
  'page',
  'limit',
  'search',
  'isActive',
  'templateId',
  'sortBy',
  'order',
];

export function selectProductQuery(s: FiltersState): ProductListQuery {
  const out: ProductListQuery = {};
  for (const k of QUERY_KEYS) {
    const v = s[k];
    if (v !== undefined && v !== '') (out as Record<string, unknown>)[k] = v;
  }
  return out;
}
